import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/LanguageContext";

const PaymentThankYou = ({ onReset }) => {
  const { t } = useLanguage();

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className="mb-12"
    >
      <div className="glass-card rounded-2xl p-10 glow-yellow text-center max-w-2xl mx-auto">
        <div className="w-16 h-16 rounded-full bg-green-500/10 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-8 h-8 text-green-400" />
        </div>
        <h3 className="font-bold text-2xl text-white mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
          {t("thankyou.title")}
        </h3>
        <p className="text-white/70 text-lg leading-relaxed mb-6">
          {t("thankyou.message")}
        </p>
        <p className="text-white/50">
          {t("thankyou.contact")}{" "}
          <a href="mailto:contact@reveal.ad" className="text-yellow-400 hover:text-yellow-300 transition-colors">
            contact@reveal.ad
          </a>
        </p>
        <Button
          onClick={onReset}
          className="mt-8 btn-accent rounded-xl px-6 py-3"
          data-testid="analyze-more-btn"
        >
          {t("thankyou.button")}
          <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </motion.div>
  );
};

export default PaymentThankYou;
